import { IMethodParam, IPropsUseSetTrackEvent } from './interface'

// eslint-disable-next-line @typescript-eslint/ban-types
export type IPushParams = [IMethodParam, (string | object)?]

declare global {
    interface Window {
        _hsq: { push: (callParam: IPushParams) => void }
    }
}

export type IHubspotTracking = {
    setContentType: (contentType: string) => void
    setPathPageView: (path: string) => void
    setTrackPageView: () => void
    // eslint-disable-next-line @typescript-eslint/ban-types
    setIdentity: (email: string, customPropertities?: {}) => void
    setTrackEvent: ({ eventId, value }: IPropsUseSetTrackEvent) => void
}

const useHubspotTracking = (): IHubspotTracking => {
    const _hsq = typeof window !== 'undefined' && window._hsq ? window._hsq : [] as IPushParams[]

    const setContentType = (contentType: string): void => {
        _hsq.push(['setContentType', contentType])
    }

    const setTrackPageView = () => {
        _hsq.push(['trackPageView'])
    }

    const setPathPageView = (path: string): void => {
        // This function updates the path
        _hsq.push(['setPath', path])
        // This function track the current updated page path
        setTrackPageView()
    }

    // eslint-disable-next-line @typescript-eslint/ban-types
    const setIdentity = (email: string, customPropertities?: {}) => {
        _hsq.push([
            'identify',
            {
                email,
                ...customPropertities
            }
        ])
    }

    const setTrackEvent = ({ eventId, value }: IPropsUseSetTrackEvent) => {
        _hsq.push([
            'trackEvent',
            {
                id: eventId,
                value
            }
        ])
    }

    return {
        setContentType,
        setPathPageView,
        setTrackPageView,
        setIdentity,
        setTrackEvent
    }
}

export default useHubspotTracking